import styled from 'styled-components';

import { spaceS } from '@xing-com/tokens';

export const HorizontalItem = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: ${spaceS};
`;

export const Title = styled.p`
  margin: 0;
  text-decoration: none;
  text-align: left;
  white-space: nowrap;
`;
